const yellow = "/media/diamondcolor/yellow.jpg";
const blue = "/media/diamondcolor/blue.jpg";
const pink = "/media/diamondcolor/pink.jpg";
const green = "/media/diamondcolor/green.jpg";
const orange = "/media/diamondcolor/orange.jpg";
const red = "/media/diamondcolor/red.jpg";

export const color_diamonds = {
    "y": "Yellow",
    "o": "Orange",
    "pk": "Pink",
    "b": "Blue",
    "gr": "Green",
    "r": "Red"
};

export const colorless_diamonds = {
    "d": "Colorless",
    "e": "Colorless",
    "f": "Colorless",
    "g": "Near Colorless",
    "h": "Near Colorless",
    "i": "Near Colorless",
    "j": "Near Colorless",
    "k": "Faint"
};

export const colordiamond_naturalcolor = [
    {
        label: "Yellow",
        icon: yellow,
        code: "yellow"
    },
    {
        label: "Blue",
        icon: blue,
        code: "blue"
    },
    {
        label: "Pink",
        icon: pink,
        code: "pink"
    },
];

export const colordiamond_labcolor = [
    {
        label: "Yellow",
        icon: yellow,
        code: "yellow"
    },
    {
        label: "Blue",
        icon: blue,
        code: "blue"
    },
    {
        label: "Pink",
        icon: pink,
        code: "pink"
    },
    {
        label: "Green",
        icon: green,
        code: "green"
    },
    {
        label: "Orange",
        icon: orange,
        code: "orange"
    },
    {
        label: "Red",
        icon: red,
        code: "red"
    },
];

export const colordiamond_intensity = [
    {
        label: "Faint",
        code: "Faint"
    },
    {
        label: "Very Light",
        code: "Very Light"
    },
    {
        label: "Light",
        code: "Light"
    },
    {
        label: "Fancy Light",
        code: "Fancy Light"
    },
    {
        label: "Fancy",
        code: "Fancy"
    },
    {
        label: "Intense",
        code: "Intense"
    },
    {
        label: "Vivid",
        code: "Fancy Vivid"
    },
    {
        label: "Dark",
        code: "Fancy Dark"
    },
    {
        label: "Deep",
        code: "Fancy Deep"
    },
];